import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { Box, Paper, Drawer, Hidden } from "@material-ui/core/"

const SideImage = ({ logo }) => {
  return (
    <div style={{ textAlign: "center", padding: "10px" }}>
      <Img fluid={logo.childImageSharp.fluid} alt="EreZ Kaynak" />
    </div>
  )
}
const SideLink = props => {
  const { navArray } = props
  return (
    <React.Fragment>
      {navArray.map((nav, index) => (
        <Link
          to={nav.url}
          key={nav.url}
          className="list-link"
          activeClassName="list-link-active"
        >
          <div className="list-link-wrapper">
            <span className="list-icon">&#x276F;</span>
            <span className="list-text"> {nav.title}</span>
          </div>
        </Link>
      ))}
    </React.Fragment>
  )
}
const SideBar = props => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      navigation: file(relativePath: { eq: "navigation.json" }) {
        childDataJson {
          mainNav {
            title
            url
          }
          sideNav {
            title
            url
          }
        }
      }
    }
  `)
  const nData = data.navigation.childDataJson

  return (
    <React.Fragment>
      <Hidden smDown implementation="js">
        <div className="sidenav-desktop ">
          <div className="sidenav-desktop-nav scrollbar">
            <Box p={2}>
              <Paper elevation={4} style={{ overflow: "hidden" }}>
                <Box p={1}>
                  <SideLink navArray={nData.sideNav} />
                </Box>
              </Paper>
            </Box>
          </div>
        </div>
      </Hidden>
      <Hidden mdUp implementation="js">
        <Drawer anchor="left" open={props.mOpen} onClose={props.menuBar}>
          <Box p={2}>
            <SideImage logo={data.logo} />
            <SideLink navArray={nData.mainNav} />
            <SideLink navArray={nData.sideNav} />
          </Box>
        </Drawer>
      </Hidden>
    </React.Fragment>
  )
}
export default SideBar
